import { DocumentNode, gql } from '@apollo/client';

type Bp = {
  name: string;
  id: number;
};
const BP_QUERY = gql`
  query getKundenUndLieferanten(
    $categoryCodes: [Int]
    $querySize: Int
    $queryPage: Int
    $querySortOrder: SortOrderStyle
    $querySortBy: String
    $querySortByEx: [SortByPair]
    $filter: String
    $addFavSort: Boolean
    $onlyFavItems: Boolean
  ) {
    getKunden: getKunden(
      categoryCodes: $categoryCodes
      querySize: $querySize
      queryPage: $queryPage
      querySortOrder: $querySortOrder
      querySortBy: $querySortBy
      querySortByEx: $querySortByEx
      filter: $filter
      addFavSort: $addFavSort
      onlyFavItems: $onlyFavItems
    ) {
      total
      size
      page
      data {
        id: code
        name: name
        __typename
      }
      __typename
    }

    getLieferanten: getLieferanten(
      categoryCodes: $categoryCodes
      querySize: $querySize
      queryPage: $queryPage
      querySortOrder: $querySortOrder
      querySortBy: $querySortBy
      querySortByEx: $querySortByEx
      filter: $filter
      addFavSort: $addFavSort
      onlyFavItems: $onlyFavItems
    ) {
      total
      size
      page
      data {
        id: code
        name: name
        __typename
      }
      __typename
    }
  }
`;

type User = {
  displayName: string;
  id: number;
};
const USER_QUERY = gql`
  query getBenutzer(
    $querySize: Int
    $queryPage: Int
    $querySortOrder: SortOrderStyle
    $querySortBy: String
    $querySortByEx: [SortByPair]
    $filter: String
  ) {
    getBenutzer(
      querySize: $querySize
      queryPage: $queryPage
      querySortOrder: $querySortOrder
      querySortBy: $querySortBy
      querySortByEx: $querySortByEx
      filter: $filter
    ) {
      total
      size
      page
      sortBy
      sortOrder
      data {
        displayName: anzeigename
        id: code
      }
    }
  }
`;

type PositionFilterMapping<T = unknown> = {
  sourceId: string;
  targetId: string;
  transform?: (val: T[]) => unknown;
};

type ErpFilterMapping<T = unknown> = {
  sourceId: string;
  targetId: string;
  query?: DocumentNode;
  buildVariables?: (val: T[]) => unknown;
};

export const POSITIONS_FILTER_MAPPINGS: PositionFilterMapping[] = [
  {
    sourceId: 'businessPartnerContactCombined.businessPartner.data.id',
    targetId: 'details.bz_Company_Name',
    transform: (val: Bp[]) => val.map((x) => x.name),
  },
  {
    sourceId: 'user.id',
    targetId: 'details.bz_UserResponsible',
    transform: (val: User[]) => val.map((x) => x.displayName),
  },
  {
    sourceId: 'date',
    targetId: 'details.bz_Date',
  },
  {
    sourceId: 'contractDate',
    targetId: 'details.bz_Date',
  },
  // ...
  // Add more positions mappings here
];

export const ERP_FILTER_MAPPINGS: ErpFilterMapping[] = [
  {
    sourceId: 'details.bz_Company_Name',
    targetId: 'businessPartnerContactCombined.businessPartner.data.id',
    query: BP_QUERY,
    buildVariables: (val: Bp[]) => [{ name: { $in: val } }],
  },
  {
    sourceId: 'details.bz_UserResponsible',
    targetId: 'user.id',
    query: USER_QUERY,
    buildVariables: (val: User[]) => [{ anzeigename: { $in: val } }],
  },
  {
    sourceId: 'details.bz_Date',
    targetId: 'date',
  },
  {
    sourceId: 'details.bz_Date',
    targetId: 'contractDate',
  },
  // ...
  // Add more ERP mappings here
];
